import { type FC, Fragment, memo, type PropsWithChildren, type ReactNode } from "react";

export interface JoinProps {
  delimiter: ReactNode;
}

export const Join: FC<PropsWithChildren<JoinProps>> = memo(({ children, delimiter }) => {
  if (!Array.isArray(children)) {
    throw new TypeError("Prop `children` must be an array");
  }

  const nonEmptyChildren = children.filter(Boolean);

  return (
    <>
      {nonEmptyChildren.map((child, index) => (
        <Fragment key={index}>
          {index > 0 && delimiter}
          {child}
        </Fragment>
      ))}
    </>
  );
});
Join.displayName = "Join";
